export default __webpack_public_path__ + "static/media/back-arrow-pink.e24efb6e.svg";